module.exports = __webpack_public_path__ + "assets/img/analysisOverview-active.241800d8.svg";